import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
    Person,
    useGetCustomerQuery,
    useUpdateCustomerMutation,
} from '../../../../generated/graphql'
import Loading from '../../../loading'
import CustomerForm from '../customerForm'

const UpdateCustomer = () => {
    const params = useParams()
    const navigate = useNavigate()
    const { id } = params

    const { data, loading: loadingGetCustomer } = useGetCustomerQuery({
        variables: {
            data: {
                id,
            },
        },
    })

    const [updateCustomer, { loading: loadingUpdate }] =
        useUpdateCustomerMutation()

    const submit = React.useCallback(
        (person: Person) => {
            updateCustomer({
                variables: {
                    data: {
                        id,
                        name: person.name,
                        surname: person.surname,
                        email: person.email,
                        phone: person.phone,
                        city: person.city,
                        dni: person.dni,
                        diffusion: person.customer?.diffusion,
                        wantReceiveInfo: person.customer?.wantReceiveInfo,
                        imageRights: person.customer?.imageRights,
                        contactChannel: person.customer?.contactChannel,
                        howDiscovered: person.customer?.howDiscovered,
                        documentType: person.customer?.documentType,
                        signatureDate: person.customer?.signatureDate,
                    },
                },
                onCompleted() {
                    navigate('/people/customers')
                },
                refetchQueries: ['getCustomers', 'getPeople'],
            })
        },
        [navigate, id, updateCustomer]
    )
    const customerForm = React.useMemo(() => {
        return data?.customer ? (
            <CustomerForm customer={data?.customer} submit={submit} />
        ) : null
    }, [data?.customer, submit])

    return loadingGetCustomer || loadingUpdate ? <Loading /> : customerForm
}

export default React.memo(UpdateCustomer)
